<template>
    <section class="mobileNot">
        <div id="headerPlano" :class="[builderMode === 'module' ? 'flexContainer jc-fe' : lock === 'true' ? 'flexContainer' : '']">
            <button v-if="builderMode !== 'module'" class="btnLeft uppercase export pointer" @click="exportPdf">
                <span>{{ $t("planobuilder.export") }}</span>
            </button>
            <div class="flexContainer lock full" v-if="lock === 'true' || access === 'false'">
                <h2 class="uppercase lockText center">
                    <img class="lockScreenLogo" src="../../../static/img/lockScreen.svg" alt="" /> {{ $t("plano.lock") }}
                </h2>
            </div>
            <button
                v-if="builderMode !== 'module' && lock === 'false' && access === 'true'"
                class="btnLeft uppercase support pointer"
                :class="{ active: support }"
            >
                <span
                    ><a target="_blank" class="supportLink" :href="globals + '/Plano-Builder-Guide-utilisateur.pdf'">{{
                        $t("planobuilder.support")
                    }}</a></span
                >
            </button>
            <button
                v-if="builderMode !== 'module' && lock === 'false' && access === 'true'"
                class="btnLeft uppercase comment pointer"
                :class="{ active: comment }"
                @click="comments"
            >
                <span>{{ $t("planobuilder.comment") }} ({{ commentsNB }})</span>
            </button>
            <button
                v-if="builderMode !== 'module' && lock === 'false' && access === 'true'"
                class="btnBase uppercase favorites fright pointer"
                :class="{ active: favorite }"
                @click="favorites"
            >
                <span>{{ $t("planobuilder.favorite") }}</span>
            </button>
            <button
                v-if="builderMode !== 'module' && lock === 'false' && access === 'true'"
                class="btnBase uppercase scratch fright pointer"
                :class="{ active: scratch }"
                @click="scratchPad"
            >
                <span>{{ $t("planobuilder.scratch") }}</span>
            </button>
            <button
                v-if="builderMode !== 'module' && lock === 'false' && access === 'true'"
                class="btnBase uppercase library fright pointer"
                :class="{ active: menuHeader }"
                @click="library"
            >
                <span>{{ $t("planobuilder.library") }}</span>
            </button>
            <button
                v-if="builderMode === 'module' && lock === 'false' && access === 'true'"
                class="btnBase uppercase shades pointer"
                :class="{ active: menuShades }"
                @click="shades"
            >
                <span>{{ $t("planobuilder.shades") }}</span>
            </button>
        </div>
    </section>
</template>

<script>
import { bus } from "../../main";
import Vuex from "vuex";
import Globals from "../globals";
import cacheService from "@/services/cache";

export default {
    data: () => ({
        menuHeader: false,
        menuShades: false,
        scratch: false,
        menu: false,
        favorite: false,
        comment: false,
        support: false,
        builderMode: "",
        lock: "",
        commentsNB: "",
        globals: Globals.getBaseUrl(),
        access: null
    }),
    watch: {
        retMode: function(val) {
            this.builderMode = val;
        },
        retCom: function(val) {
            this.commentsNB = val;
        }
    },
    methods: {
        exportPdf() {
            bus.$emit("exportPdf");
        },
        comments() {
            this.comment = !this.comment;
            bus.$emit("openComments", this.comment);
        },
        favorites() {
            this.favorite = !this.favorite;
            bus.$emit("openFavorite", this.favorite);
        },
        scratchPad() {
            this.scratch = !this.scratch;
            bus.$emit("openScratch", this.scratch);
        },
        library() {
            this.menuHeader = !this.menuHeader;
            bus.$emit("openLibrary", this.menuHeader);
            this.$router.push({ name: "Plano", query: this.getLinkParams({ type: 1 }) });
        },
        shades() {
            let idModule = this.$store.state.plano.status.builder.idModule;
            this.menuShades = !this.menuShades;
            bus.$emit("openShades", this.menuShades);
            bus.$emit("idModule", idModule);
        },
        getLinkParams(x) {
            const temp = {};
            for (let key in this.$route.query) {
                if (x[key] !== null) {
                    temp[key] = this.$route.query[key];
                }
            }

            for (let key in x) {
                if (x[key] !== null) {
                    temp[key] = x[key];
                }
            }
            return temp;
        }
    },
    mounted() {
        setInterval(() => {
            this.access = cacheService.get("planoAccess");
        }, 3000);
    },
    computed: {
        retMode() {
            return this.$store.state.plano.status.builder.mode;
        },
        retCom() {
            return this.$store.state.plano.data.commentNb;
        },
        ...Vuex.mapGetters({
            getComments: "plano/data/getComments",
            getCommentsNb: "plano/data/getCommentsNb"
        })
    },
    created() {
        this.$store.dispatch("plano/data/getComments", { id: this.$route.params.id }).then(() => {
            this.commentsNB = this.getComments.length;
        });
        bus.$on("openLibrary", event => {
            this.menuShades = false;
            this.comment = false;
            this.scratch = false;
            this.favorite = false;
        });
        bus.$on("openShades", event => {
            this.menuHeader = false;
            this.comment = false;
            this.scratch = false;
            this.favorite = false;
        });
        bus.$on("openComments", event => {
            this.menuShades = false;
            this.menuHeader = false;
            this.scratch = false;
            this.favorite = false;
        });
        bus.$on("openScratch", event => {
            this.menuShades = false;
            this.menuHeader = false;
            this.favorite = false;
            this.comment = false;
        });
        bus.$on("openFavorite", event => {
            this.menuShades = false;
            this.menuHeader = false;
            this.scratch = false;
            this.comment = false;
        });
        bus.$on("moduleClosed", event => {
            this.menuShades = false;
            this.menuHeader = false;
        });
        this.lock = cacheService.get("planoLocked");
    }
};
</script>

<style lang="scss" scoped>
.lock {
    /*width: 10%;*/
}
#library {
    background-color: white;
    width: 25%;
    right: 0;
    height: 10vh;
}
#headerPlano {
    background-color: white;
    padding: 0 20px;
    position: relative;
    z-index: 25;
    button {
        padding: 20px 0;
        &.active {
            border-bottom: 1px solid #343434;
        }
    }
    .btnBase {
        border: none;
        background-color: white;
        font-family: Roboto;
        font-size: 14px;
        color: #343434;
        &.active {
            font-weight: 500;
            border-bottom: 2px solid #343434;
        }
    }
    .btnLeft {
        border: none;
        background-color: white;
        font-family: Roboto;
        font-size: 14px;
        color: #343434;
        &.active {
            font-weight: 500;
            border-bottom: 2px solid #343434;
        }
    }
    .export,
    .support,
    .comment,
    .scratch,
    .library,
    .favorites {
        .supportLink {
            text-decoration: none;
            color: #343434;
            &:visited {
                color: #343434;
            }
        }

        span {
            border-right: 1px solid #a8a8a8;
            padding: 0 29px;
        }
        .shades {
            padding: 30px;
        }
    }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
    #headerPlano {
        display: flex;
        .btnBase,
        .btnLeft {
            font-size: 1.15rem;
        }
    }
}
</style>



// WEBPACK FOOTER //
// HeaderPlano.vue?3ad4f4d0